import { FC, lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import {
	SHOW_SHOP_SECTIONS,
	SHOW_STRATAPAY_SECTIONS,
	SHOW_TELEGRAM_SECTIONS,
} from '../config/environment';
import TopBarProgress from 'react-topbar-progress-indicator';
import { WithChildren } from '../../_metronic/helpers';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import { ArbiterCard } from '../modules/apps/deals-card/ArbiterCard';
import { ArbiterCardEarly } from '../modules/apps/deals-card/ArbiterCardEarly';
import { DealCard } from '../modules/apps/deals-card/DealCard';
import { FeedPostsPage } from '../modules/apps/feed-posts/FeedPostsPage';
import { PostFormPage } from '../modules/apps/feed-posts/posts-form/ui/PostFormPage';
import { FeedTagsPage } from '../modules/apps/feed-tags/FeedTagsPage';
import { CategoryGroupsPage } from '../modules/apps/telegram-forum/ui/CategoryGroupsPage';
import { ShopTopicsPage } from '../modules/apps/telegram-forum/ui/ShopTopicsPage';
import { TelegramForumPage } from '../modules/apps/telegram-forum/ui/TelegramForumPage';
import { SubscriptionPage } from '../modules/apps/subsribtion/subscription-table/SubscriptionPage'
import { FreeRequestsPage } from '../modules/apps/free-subscription-requests/ui/FreeRequestsPage'
import { ThemesPage } from '../modules/apps/themes/ThemesPage'
import { ShopsPage } from '../modules/apps/shops/ui/ShopsPage'
import { ShopCardPage } from '../modules/apps/shops/ui/ShopCardPage'

const PrivateRoutes = () => {
	const UsersPage = lazy(
		() => import('../modules/apps/user-management/UsersPage')
	);

	const ProfilePage = lazy(() => import('../modules/apps/profile/ProfilePage'));

	const FaqPage = lazy(() => import('../modules/apps/faq/FaqPage'));

	const DealsPage = lazy(
		() => import('../modules/apps/deals-management/DealsPage')
	);

	const OffersPage = lazy(
		() => import('../modules/apps/offers-management/OffersPage')
	);

	const DisputePage = lazy(
		() => import('../modules/apps/dispute-management/DisputePage')
	);

	const WithdrawPage = lazy(
		() => import('../modules/apps/withdraw-management/WithdrawPage')
	);

	const CommissionPage = lazy(
		() => import('../modules/apps/commission-management/CommissionPage')
	);

	const ArbitratorsPage = lazy(
		() => import('../modules/apps/arbitrators-management/ArbitratorsPage')
	);

	const MetricsPage = lazy(
		() => import('../modules/apps/metrics-management/MetricsPage')
	);

	const AutomaticPage = lazy(
		() => import('../modules/apps/automatic-wthdrawal-management/MetricsPage')
	);

	const PrivateKeyPage = lazy(
		() => import('../modules/apps/wallet-management/PrivateKeyPage')
	);

	const ManualDepositPage = lazy(
		() => import('../modules/apps/bnb-wallet-management/ManualDepositPage')
	);

	const BnbDepositsPage = lazy(
		() => import('../modules/apps/bnb-wallet-management/DepositsPage')
	);

	const SettingsPage = lazy(
		() => import('../modules/apps/settings/SettingsPage')
	);

	const PaymentServicesPage = lazy(
		() => import('../modules/apps/settings/PaymentServicesPage')
	);

	const CryptomusWalletsPage = lazy(
		() => import('../modules/apps/cryptomus-wallets/CryptomusWalletsPage')
	);

	const StratapayPage = lazy(
		() =>
			import('../modules/apps/payments-gateway-management/PaymentsGatewayPage')
	);

	return (
		<Routes>
			<Route element={<MasterLayout />}>
				{/* Redirect to Dashboard after success login/registartion */}
				<Route
					path='auth/*'
					element={<Navigate to='/apps/user-management' />}
				/>
				{/* Pages */}
				<Route path='/' element={<Navigate to='/apps/user-management' />} />
				<Route
					path='apps/user-management/*'
					element={
						<SuspensedView>
							<UsersPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/profile/*'
					element={
						<SuspensedView>
							<ProfilePage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/*'
					element={
						<SuspensedView>
							<FaqPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/offer-management/*'
					element={
						<SuspensedView>
							<OffersPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/deals-management/*'
					element={
						<SuspensedView>
							<DealsPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/dispute-management/*'
					element={
						<SuspensedView>
							<DisputePage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/deal/:uuid'
					element={
						<SuspensedView>
							<DealCard />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/commission-management/*'
					element={
						<SuspensedView>
							<CommissionPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/dispute-deal/:uuid'
					element={
						<SuspensedView>
							<ArbiterCard />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/early-deal/:uuid'
					element={
						<SuspensedView>
							<ArbiterCardEarly />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/arbitrators-management/*'
					element={
						<SuspensedView>
							<ArbitratorsPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/metrics-management/*'
					element={
						<SuspensedView>
							<MetricsPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/:network/withdraw-management/*'
					element={
						<SuspensedView>
							<WithdrawPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/:network/automatic-management/*'
					element={
						<SuspensedView>
							<AutomaticPage />
						</SuspensedView>
					}
				/>

				{/* Скрытого в меню раздела мало: по прямой ссылке он всё равно
				    открывается. Раз переезд заморожен, в проде его не должно
				    быть вовсе. */}
				{SHOW_STRATAPAY_SECTIONS && (
					<Route
						path='apps/stratapay/*'
						element={
							<SuspensedView>
								<StratapayPage />
							</SuspensedView>
						}
					/>
				)}

				<Route
					path='apps/feed/tags'
					element={
						<SuspensedView>
							<FeedTagsPage />
						</SuspensedView>
					}
				/>
				<Route
					path='apps/feed/posts'
					element={
						<SuspensedView>
							<FeedPostsPage />
						</SuspensedView>
					}
				/>
				<Route
					path='apps/feed/posts/create'
					element={
						<SuspensedView>
							<PostFormPage />
						</SuspensedView>
					}
				/>
				<Route
					path='apps/feed/posts/edit/:uuid'
					element={
						<SuspensedView>
							<PostFormPage />
						</SuspensedView>
					}
				/>
				{/* Обе дороги ведут на одну страницу новостей: apps/feed/telegram
				    остался с прежней раскладки меню. Гасить надо обе — иначе
				    скрытый раздел открывается по старой ссылке. */}
				{SHOW_TELEGRAM_SECTIONS && (
					<Route
						path='apps/feed/telegram'
						element={
							<SuspensedView>
								<TelegramForumPage />
							</SuspensedView>
						}
					/>
				)}
				{SHOW_TELEGRAM_SECTIONS && (
					<Route
						path='apps/telegram/news'
						element={
							<SuspensedView>
								<TelegramForumPage />
							</SuspensedView>
						}
					/>
				)}
				{/* Два флага сразу: страница и внутри раздела Telegram, и про
				    магазины — гаснет от любого из выключателей. */}
				{SHOW_TELEGRAM_SECTIONS && SHOW_SHOP_SECTIONS && (
					<Route
						path='apps/telegram/categories'
						element={
							<SuspensedView>
								<CategoryGroupsPage />
							</SuspensedView>
						}
					/>
				)}
				{/* Топики магазинов — тоже раздел про магазины, и живёт он по
				    тем же правилам, что подписки с темами. Раньше стоял без
				    флага просто потому, что появился раньше него. */}
				{SHOW_TELEGRAM_SECTIONS && SHOW_SHOP_SECTIONS && (
					<Route
						path='apps/telegram/topics'
						element={
							<SuspensedView>
								<ShopTopicsPage />
							</SuspensedView>
						}
					/>
				)}
				{/* Прятать раздел только в меню, оставив маршрут живым, —
				    полумера: в проде он всё равно открывался по прямой
				    ссылке. Раз разделы считаются сырыми, их там не должно
				    быть вовсе. */}
				{SHOW_SHOP_SECTIONS && (
					<Route
						path='apps/shops'
						element={
							<SuspensedView>
								<ShopsPage />
							</SuspensedView>
						}
					/>
				)}

				{SHOW_SHOP_SECTIONS && (
					<Route
						path='apps/shops/:uuid'
						element={
							<SuspensedView>
								<ShopCardPage />
							</SuspensedView>
						}
					/>
				)}

				{SHOW_SHOP_SECTIONS && (
					<Route
						path='apps/subscription/free-requests'
						element={
							<SuspensedView>
								<FreeRequestsPage />
							</SuspensedView>
						}
					/>
				)}

				{SHOW_SHOP_SECTIONS && (
					<Route
						path='apps/subscription'
						element={
							<SuspensedView>
								<SubscriptionPage />
							</SuspensedView>
						}
					/>
				)}

				{SHOW_SHOP_SECTIONS && (
					<Route
						path='apps/themes'
						element={
							<SuspensedView>
								<ThemesPage />
							</SuspensedView>
						}
					/>
				)}

				<Route
					path='apps/settings'
					element={
						<SuspensedView>
							<SettingsPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/payment-services'
					element={
						<SuspensedView>
							<PaymentServicesPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/cryptomus/wallets'
					element={
						<SuspensedView>
							<CryptomusWalletsPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/bep20/wallet-management/manual-deposit'
					element={
						<SuspensedView>
							<ManualDepositPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/bep20/wallet-management/deposits'
					element={
						<SuspensedView>
							<BnbDepositsPage />
						</SuspensedView>
					}
				/>

				<Route
					path='apps/:network/wallet-management/*'
					element={
						<SuspensedView>
							<PrivateKeyPage />
						</SuspensedView>
					}
				/>

				{/* Page Not Found */}
				<Route path='*' element={<Navigate to='/error/404' />} />
			</Route>
		</Routes>
	);
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
	TopBarProgress.config({
		barThickness: 1,
		shadowBlur: 5,
	});
	return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
